if(BSS_B2B) {
  if(window.location.pathname === "account/register" ) {
    setTimeout(() =>{
      const passwordField = $(".password-field");
      const bssField = $("#bss-b2b-registration-form-render");
      if (passwordField.length && bssField) {
        passwordField.after(bssField);
      }
    }, 300)
  }
}